import React, { Component } from 'react';
import emailjs from 'emailjs-com';

class ContactForm extends Component {
  sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm(
      'your_service_id', // replace
      'your_template_id', // replace
      e.target,
      'your_public_key' // replace
    ).then(
      (result) => {
        alert('Message Sent Successfully!');
        console.log(result.text);
      },
      (error) => {
        alert('Failed to send message.');
        console.log(error.text);
      }
    );

    e.target.reset(); // Clear form
  };

  render() {
    return (
      <div className="widget ltn__form-widget">
        <h4 className="ltn__widget-title ltn__widget-title-border-2">Drop Message For Book</h4>
        <form onSubmit={this.sendEmail}>
          <input type="text" name="yourname" placeholder="Your Name*" required />
          <input type="email" name="youremail" placeholder="Your e-Mail*" required />
          <textarea name="yourmessage" placeholder="Write Message..." required />
          <button type="submit" className="btn theme-btn-1" style={{ borderRadius: '10px' }}>
            Send Message
          </button>
        </form>
      </div>
    );
  }
}

export default ContactForm;
